import { containers } from '@ecosystem/newron-design-system';
import React from 'react';
import { SaleType } from '@models/Products';
import { PERFORMANCE_ANALYSIS_RETAILER_CARD_TITLE } from '@pages/Utilities';
import { ShareType } from '@utils/pageConfig/Types';
import ExploreTrendsStackChart from '@data-visualization/trends-stack-chart/ExploreTrendsStackChart';
import { ExportExploreTrendsStack } from '@data-visualization/trends-stack-chart/Types';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { SortFieldDisplayProps } from '@components/design/migrated/Table';

export interface PerformanceAnalysisRetailerCardProps {
  data: ExportExploreTrendsStack;
  selectedGrowthType?: GrowthTypes;
  selectedSaleType: SaleType;
  noResultHandler: () => void;
  noPeriodExistForMulticountry?: boolean;
  selectedAbsoluteType: ShareType;
  stackedChartSortingOrder?: SortFieldDisplayProps;
}

const ExploreTrendsRetailerCard: React.FC<PerformanceAnalysisRetailerCardProps> = ({
  data,
  selectedGrowthType,
  selectedSaleType,
  noResultHandler,
  noPeriodExistForMulticountry,
  selectedAbsoluteType,
  stackedChartSortingOrder,
}) => {
  const { Card } = containers;
  return (
    <div>
      <Card>
        <Card.Title title={PERFORMANCE_ANALYSIS_RETAILER_CARD_TITLE}></Card.Title>
        <ExploreTrendsStackChart
          data={data}
          selectedGrowthType={selectedGrowthType}
          noResultHandler={noResultHandler}
          noPeriodExistForMulticountry={noPeriodExistForMulticountry}
          selectedSaleType={selectedSaleType}
          selectedAbsoluteType={selectedAbsoluteType}
          isMarket={false}
          stackedChartSortingOrder={stackedChartSortingOrder}
        />
      </Card>
    </div>
  );
};

export default ExploreTrendsRetailerCard;
